import transform from '../transform';

import {
    ACCOUNT_URL,
    BASE_URL,
    CHANGE_PLAN_NON_ADMIN_PATH,
    CHANGE_PLAN_SALES_PATH,
    LEGACY,
    PACKAGE_ONE,
    PACKAGE_SELECTION_PATH,
    PACKAGE_THREE,
    PACKAGE_TWO,
    USER_EVENT_ATTENDEE,
    USER_PREBUYER,
    OVERVIEW_PAGE,
} from '../../constants/main';

const CREATE_PARENT = 'createParent';
const CREATE_NON_ADMIN = 'createNonAdmin';
const COPY_PARENT = 'copyParent';
const COPY_NON_ADMIN = 'copyNonAdmin';

const CHANGE_PLAN_USER_TYPE_REDIRECTION = {
    [USER_PREBUYER]: ACCOUNT_URL,
    [USER_EVENT_ATTENDEE]: ACCOUNT_URL,
};

const CHANGE_PLAN_REDIRECTION = {
    [LEGACY]: {
        true: `${BASE_URL}${CHANGE_PLAN_NON_ADMIN_PATH}`,
        false: `${BASE_URL}${PACKAGE_SELECTION_PATH}`,
    },
    [PACKAGE_THREE]: {
        true: `${BASE_URL}${CHANGE_PLAN_NON_ADMIN_PATH}`,
        false: `${BASE_URL}${CHANGE_PLAN_SALES_PATH}`,
    },
    [PACKAGE_TWO]: {
        true: `${BASE_URL}${CHANGE_PLAN_NON_ADMIN_PATH}`,
    },
    [PACKAGE_ONE]: {
        true: `${BASE_URL}${CHANGE_PLAN_NON_ADMIN_PATH}`,
    },
};

/*
    This function acts as a gateway to ensure that the user
    has permission to view /onboarding
 */
export const checkAccess = ({ getState }, replace) => {
    const { user: { canAccessLegacyConvert, isAuthenticated } = {} } =
        getState();

    if (!isAuthenticated) {
        replace(`${BASE_URL}`);
    } else if (!canAccessLegacyConvert) {
        replace(`${BASE_URL}${CHANGE_PLAN_NON_ADMIN_PATH}`);
    }
};

/*
    This function acts as a gateway to ensure the user's access
    to the change plan pages. It will detect cases when the user should
    be:
        - redirected to a denied page indicating user cannot change plan
        - redirected to an alternative plans page
        - stay on the page
 */
export const checkChangePlanAccess = ({ getState }, replace) => {
    const {
        user: {
            userPlan,
            userType,
            canChangePlan,
            canAccessLegacyConvert,
        } = {},
    } = getState();
    let url = BASE_URL;
    const shouldRedirectToDenialPage = !canChangePlan;

    if (userType) {
        url = CHANGE_PLAN_USER_TYPE_REDIRECTION[userType];
    } else if (userPlan) {
        url = CHANGE_PLAN_REDIRECTION[userPlan][shouldRedirectToDenialPage];
    } else if (canAccessLegacyConvert) {
        // If legacy non admin user, send to /change-plan/access
        url = `${BASE_URL}${CHANGE_PLAN_NON_ADMIN_PATH}`;
    } else {
        // EB-203406
        // props are null / false | no user data should redirect to organizer/overview instead of baseURL
        url = `${BASE_URL}${OVERVIEW_PAGE}`;
    }
    // Note that, if url is undefined, no redirect will happen.
    replace(url);
};

/*
    Sets the onboarding type depending on where the user came from
    and if the user is a parent or non admin user.
 */
export const getOnboardingType = (canAccessLegacyConvert, isCreate, isCopy) => {
    let onboardingType = CREATE_PARENT;

    if (isCreate && canAccessLegacyConvert) {
        onboardingType = CREATE_NON_ADMIN;
    } else if (isCopy && canAccessLegacyConvert) {
        onboardingType = COPY_NON_ADMIN;
    } else if (isCopy) {
        onboardingType = COPY_PARENT;
    }

    return onboardingType;
};

export const getOnboardingProps = (
    {
        locale,
        isAuthenticated,
        goToPackageSelection,
        setPackageTwo,
        copySetPackageTwo,
        canAccessLegacyConvert,
        isCreate,
        isCopy,
    },
    defaultSettings,
) => {
    const {
        packageSelectionPrompt,
        nonAdminPrompt,
        copyPackageSelectionPrompt,
        copyNonAdminPrompt,
    } = transform({
        locale,
        isAuthenticated,
        defaultSettings,
    });

    const onboardingType = getOnboardingType(
        canAccessLegacyConvert,
        isCreate,
        isCopy,
    );

    const onboardingMap = {
        [CREATE_PARENT]: {
            onboardingPrompt: packageSelectionPrompt,
            onPrimaryCTAClick: goToPackageSelection,
        },
        [CREATE_NON_ADMIN]: {
            onboardingPrompt: nonAdminPrompt,
            onPrimaryCTAClick: setPackageTwo,
        },
        [COPY_PARENT]: {
            onboardingPrompt: copyPackageSelectionPrompt,
            onPrimaryCTAClick: goToPackageSelection,
        },
        [COPY_NON_ADMIN]: {
            onboardingPrompt: copyNonAdminPrompt,
            onPrimaryCTAClick: copySetPackageTwo,
        },
    };

    return onboardingMap[onboardingType];
};
